// Monitoring-app route tree.
// Composed from `sharedRoutes.jsx` plus monitoring-only pages.

import { Navigate } from 'react-router';

import { AppLayout } from 'app/layouts/AppLayout';
import { DynamicLayout } from 'app/layouts/DynamicLayout';
import OnboardingPage from 'app/pages/shared/onBoarding/onBoardingPage';
import TenantSelectorPage from 'app/pages/shared/TenantSelectorPage';
import AdminTenantGuard from 'middleware/AdminTenantGuard';
import AuthGuard from 'middleware/AuthGuard';
import ModuleRoleGuard from 'middleware/ModuleRoleGuard';

import {
  alertDetailsRoute,
  alertsRoutes,
  dashboardRoute,
  deviceManagementRoutes,
  devicesLegacyRedirects,
  helpRoute,
  reportsRoutes,
  settingsRoutes,
} from '../sharedRoutes';

// ----------------------------------------------------------------------

const protectedRoutes = {
  id: 'protected',
  Component: AuthGuard,
  children: [
    {
      path: 'select-tenant',
      element: <TenantSelectorPage />,
    },
    {
      Component: AdminTenantGuard,
      children: [
        {
          children: [
            {
              index: true,
              element: <OnboardingPage />,
            },
            {
              path: 'onboarding',
              element: <OnboardingPage />,
            },
          ],
        },
        {
          Component: ModuleRoleGuard,
          children: [
            {
              Component: DynamicLayout,
              children: [
                dashboardRoute,
                reportsRoutes,
                alertsRoutes,
                {
                  path: 'analytics',
                  lazy: async () => ({
                    Component: (
                      await import('app/pages/shared/reports/DataAnalytics')
                    ).default,
                  }),
                },
                {
                  path: 'data-sharing',
                  children: [
                    {
                      index: true,
                      element: <Navigate to="/data-sharing/export" replace />,
                    },
                    {
                      path: 'export',
                      lazy: async () => ({
                        Component: (
                          await import('app/pages/monitoring/dataSharing/ExportBuilderPage')
                        ).default,
                      }),
                    },
                    {
                      path: 'recent',
                      lazy: async () => ({
                        Component: (
                          await import('app/pages/monitoring/dataSharing/RecentExportsPage')
                        ).default,
                      }),
                    },
                  ],
                },
                deviceManagementRoutes,
                devicesLegacyRedirects,
                alertDetailsRoute,
                helpRoute,
              ],
            },
            {
              Component: AppLayout,
              children: [settingsRoutes],
            },
          ],
        },
      ],
    },
  ],
};

export { protectedRoutes };
